export default __webpack_public_path__ + "static/media/invitation-con2.59799ce5.png";